var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9894 17.5908C20.733 18.0454 21.1244 18.5611 21.1244 19.086C21.1244 19.6109 20.733 20.1265 19.9894 20.5811C19.2458 21.0357 18.1762 21.4131 16.8883 21.6756C15.6003 21.938 14.1393 22.0762 12.6521 22.0762C11.1649 22.0762 9.70384 21.938 8.41588 21.6756C7.12791 21.4131 6.05838 21.0357 5.31477 20.5811C4.57116 20.1265 4.17969 19.6109 4.17969 19.086C4.17969 18.5611 4.57116 18.0454 5.31477 17.5908",
    stroke: "#222222",
    strokeWidth: 0.99675,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.129 10.6143C20.129 15.616 14.6585 18.9897 13.0769 19.8606C12.8097 20.0077 12.497 20.0077 12.2299 19.8606C10.6482 18.9897 5.17773 15.616 5.17773 10.6143C5.17773 6.12892 8.79993 3.13867 12.6534 3.13867C16.6404 3.13867 20.129 6.12892 20.129 10.6143Z",
    stroke: "#222222",
    strokeWidth: 0.99675
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.653,
    cy: 10.614,
    r: 3.48863,
    stroke: "#222222",
    strokeWidth: 0.99675
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/locationPin.29ceeb97afc234dcf55b7d477581dc15.svg";
export { ForwardRef as ReactComponent };